import { render, staticRenderFns } from "./addHospitalDialog.vue?vue&type=template&id=c05870c0"
import script from "./addHospitalDialog.vue?vue&type=script&lang=js"
export * from "./addHospitalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports